var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1895 0C4.66673 0 0.189453 4.47727 0.189453 10C0.189453 15.5227 4.66673 20 10.1895 20C15.7122 20 20.1895 15.5227 20.1895 10C20.1895 4.47727 15.7122 0 10.1895 0ZM14.9231 7.91545C15.0887 7.744 15.1803 7.51436 15.1782 7.276C15.1762 7.03764 15.0806 6.80963 14.912 6.64107C14.7435 6.47252 14.5155 6.37691 14.2771 6.37484C14.0387 6.37277 13.8091 6.4644 13.6376 6.63L8.82582 11.4418L6.74127 9.35727C6.56981 9.19168 6.34018 9.10004 6.10182 9.10211C5.86345 9.10419 5.63544 9.19979 5.46689 9.36835C5.29834 9.5369 5.20273 9.76491 5.20066 10.0033C5.19859 10.2416 5.29022 10.4713 5.45582 10.6427L8.18309 13.37C8.35357 13.5404 8.58476 13.6362 8.82582 13.6362C9.06688 13.6362 9.29806 13.5404 9.46854 13.37L14.9231 7.91545Z",
    fill: "#10C538"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.2308f1ac00e611aabcc44cfb8eb2ca0d.svg";
export { ForwardRef as ReactComponent };